import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { SelfServiceEffectsModule } from '@appStore/selfservice/effects';
import { reducers } from '@appStore/selfservice/reducers';
import * as fromServices from '@appStore/selfservice/services';

export * from '@appStore/selfservice/reducers';
export * from '@appStore/selfservice/effects';
export * from '@appStore/selfservice/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('selfservice', reducers), SelfServiceEffectsModule],
  providers: [...fromServices.services]
})
export class SelfServiceStoreModule {}
